import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreatePluginFormValues, CreatePluginForm } from './components/CreatePluginForm'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { useRequestHandler } from '@/hooks/useRequestHandler'
import { useSnackbar } from 'notistack'
import {
  addPlugin,
  getEstablishment,
  selectAdminCreateRequestTracker,
  selectAdminUpdateRequestTracker,
  selectEstablishments,
  testPlugin,
} from '@/redux/reducers/admin.reducer'
import Stack from '@mui/material/Stack'
import LoadingButton from '@mui/lab/LoadingButton'
import Dialog from '@mui/material/Dialog'
import ClearIcon from '@mui/icons-material/Clear'
import Paper from '@mui/material/Paper'
import Card from '@mui/material/Card'
import PageContainer from '@/components/ui/containers/PageContainer'
import { Button } from '@mui/material'

// TODO: rename component page
export function PluginsPage() {
  const dispatch = useAppDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const adminRequestHandler = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t('notification.plugin.create.success'), { variant: 'success' })
      setOpenDialog(false)
    },
    onError: () => enqueueSnackbar(t('notification.plugin.create.error'), { variant: 'error' }),
    requestTrackerSelector: selectAdminCreateRequestTracker,
  })

  const { t } = useTranslation()
  const establishments = useAppSelector(selectEstablishments)

  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [initialValues, setInitialValues] = useState<CreatePluginFormValues>({ pluginUrl: '', apiKey: '', apiUrl: '' })

  useEffect(() => {
    dispatch(getEstablishment())
  }, [dispatch])

  const handlePluginSubmit = (values: CreatePluginFormValues) => {
    adminRequestHandler.dispatch(addPlugin(values))
  }

  // TODO: rename
  const handlePluginCreation = (data: any) => {
    setInitialValues(data)
    setOpenDialog(true)
  }

  const testPluginRequest = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t('notification.plugin.update.success'), { variant: 'success' })
      setOpenDialog(false)
    },
    onError: () => enqueueSnackbar(t('notification.plugin.update.error'), { variant: 'error' }),
    requestTrackerSelector: selectAdminUpdateRequestTracker,
  })

  const handleTestPlugin = async (values: CreatePluginFormValues) => {
    testPluginRequest.dispatch(testPlugin(values))
  }

  return (
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <LoadingButton loading={adminRequestHandler.requestTracker.loading} onClick={() => handlePluginCreation(initialValues)} variant="contained">
          {t('page.admin.establishment.addPluginButton')}
        </LoadingButton>
      </Stack>
      {establishments.map((e) =>
        e.plugins?.map((p) => (
          <Card sx={{ px: 3, paddingBottom: 2 }} key={`${p.apiKey || ''}${p.apiUrl || ''}`.toLowerCase()}>
            {' '}
            <CreatePluginForm initialValues={p} onTest={handleTestPlugin} onSubmit={handlePluginSubmit} />
          </Card>
        ))
      )}
      <Dialog open={openDialog} onClose={() => setOpenDialog(!openDialog)}>
        <LoadingButton
          onClick={() => setOpenDialog(!openDialog)}
          sx={{ position: 'absolute', top: '5px', right: '5px' }}
          placeholder={t('page.admin.establishment.clearPluginForm')}
        >
          <ClearIcon />
        </LoadingButton>
        <Paper sx={{ mt: '50px', p: '30px' }}>
          <CreatePluginForm initialValues={initialValues} onSubmit={handlePluginSubmit} />
        </Paper>
      </Dialog>
    </Stack>
  )
}

export default PluginsPage
